<div class="container mt-card">
    <div class="card mt-5">
        <div class="title m-3 mb-0">
            <h3>
                Download Templates for Data Import
            </h3>
        </div>

        <div class="container mb-3">
            <p>Import Schedule</p>
            <div class="d-flex flex-column align-items-start">
                <a href="/assets/templates/CandidateExaminationScheduleTemplate.xlsx" download>
                    Schedule Template</a>
            </div>
            <hr>
            <p>Import Question</p>

            <div class="d-flex align-content-between justify-content-between mt-2">
                <a href="/assets/templates/Question_Upload_Format_1.txt" download>
                    Format 1 Template</a>
                <a href="/assets/templates/Question_Upload_Format_2.txt" download>
                    Format 2 Template</a>

                <a href="/assets/templates/Question Format.xlsx" download>
                    Excel Template</a>
            </div>
            <hr>

            <p>Import Passwords From Excel</p>
            <div class="d-flex flex-column align-items-start">
                <a href="/assets/templates/ImportPasswordsFromExcel.xlsx" download>
                    Import Passwords Template</a>
            </div>
        </div>

    </div>
</div>